import {VideoTileStaticImageOverlayDefaultBox} from "./video-tile-static-image-overlay-default.box";
import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";
import {VideoTileStaticImageOverlayMrGreenBox} from "./video-tile-static-image-overlay.mrgreen.box";

export const VideoTileStaticImageOverlayBox = styledByTheme(VideoTileStaticImageOverlayDefaultBox)
    .forMrGreen(VideoTileStaticImageOverlayMrGreenBox)
    .apply();
